import axios from 'axios';
import { getHeaders } from './utils';
import { AULA_ASSIGNMENTS } from '../../constants/endpoints';

const fetchGrades = ({ accessToken, assignmentId }) =>
  axios.get(`${AULA_ASSIGNMENTS()}/grades?id=${assignmentId}`, {
    headers: getHeaders(accessToken),
  });

export default fetchGrades;
